import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import editicon from "../../Assets/icon/image-edit-Icon.svg";
import CircularProgressBarProfile from "../../Components/CircularProgressBarProfile";
import GradientBackground from "../../Components/AddRelationshipHeaderGradient";
import profilecircle from "../../Assets/icon/Ellipse 86.svg";
import profile from "../../Assets/icon/user-03.svg";
import { useHeader } from "../../Providers/HeaderContextProvider";
import { getUserProfile } from "../../Services/MyProfile";
import EditPhotoModal from "../../Components/UpdateProfileModal";
import TopBar from "../../Components/AddRelationshipTopBar";
import ChatModal from "../../Components/ChatModal/ChatModal";
import PhoneSettingsScreen2 from "../Settings/PhonePopUp/PhoneSettingsScreen2";
import PhoneSettingsScreen3 from "../Settings/PhonePopUp/PhoneSettingsScreen3";
import EmailSettingsScreen2 from "../Settings/EmailPopUp/EmailSettingsScreen2";
import EmailSettingsScreen3 from "../Settings/EmailPopUp/EmailSettingsScreen3";
import LoadingScreen from "../LoadingPage/DefaultLoader";

const Profile = () => {
  const { setHeaderContent, addProfileData } = useHeader();
  const navigate = useNavigate();

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [profileDetailsLoading, setProfileDetailsLoading] = useState(true);

  const [isDesktopView, setIsDesktopView] = useState(window.innerWidth >= 768);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [showPhoneSetting, setShowPhoneSetting] = useState(false);
  const [showEmailSetting, setShowEmailSetting] = useState(false);
  const [currentPhoneScreen, setCurrentPhoneScreen] = useState(2);
  const [currentEmailScreen, setCurrentEmailScreen] = useState(2);
  const [showContactSuccessMessage, setShowContactSuccessMessage] = useState(false);
  const [showEmailSuccessMessage, setShowEmailSuccessMessage] = useState(false);
  const [currentPhone, setCurrentPhone] = useState("");
  const [currentEmail, setCurrentEmail] = useState("");
  const [emailUpdateLoading, setEmailUpdateLoading] = useState(false);

  useLayoutEffect(() => {
    setHeaderContent(false);
  }, [setHeaderContent]);

  useEffect(() => {
    const handleResize = () => setIsDesktopView(window.innerWidth >= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      setProfileDetailsLoading(true);
      try {
        const profileData = await getUserProfile();
        setUserProfile(profileData);
        setCurrentEmail(profileData?.email || "");
        setCurrentPhone(`${profileData?.mobile?.country_code || ""}${profileData?.mobile?.contact || ""}`);
      } catch (error) {
        console.error("Error fetching profile data:", error);
      } finally {
        setProfileDetailsLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const openEditModal = () => {
    setIsEditModalOpen(true);
    document.body.classList.add("no-scroll");
  };

  const closeEditModal = async () => {
    setIsEditModalOpen(false);
    document.body.classList.remove("no-scroll");
    try {
      const updated = await getUserProfile();
      setUserProfile(updated);
      setCurrentEmail(updated?.email || "");
      setCurrentPhone(`${updated?.mobile?.country_code || ""}${updated?.mobile?.contact || ""}`);
    } catch (error) {
      console.error("Error fetching updated user profile:", error);
    }
  };

  const handleProfileUpdate = (updatedProfile) => {
    localStorage.setItem("profile", JSON.stringify(updatedProfile));
    addProfileData(updatedProfile);
    setUserProfile(updatedProfile);
    localStorage.removeItem("welcomeMessage");
  };

  const fetchUserProfileLatest = async () => {
    try {
      const updated = await getUserProfile();
      localStorage.setItem("profile", JSON.stringify(updated));
      addProfileData(updated);
      setUserProfile(updated);
      setCurrentEmail(updated?.email || "");
      setCurrentPhone(`${updated?.mobile?.country_code || ""}${updated?.mobile?.contact || ""}`);
    } catch (error) {
      console.error("Error refreshing profile:", error);
    }
  };

  const formatDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return value;
    }
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };

  const formatText = (value) => {
    if (!value) return null;
    return `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
  };

  const formatGender = (value) => {
    if (!value) return null;
    const normalized = String(value).trim().toLowerCase().replace(/\s+/g, "-").replace(/_/g, "-");
    const map = {
      female: "Female",
      male: "Male",
      other: "Other",
      "non-binary": "Non-binary",
      "nonbinary": "Non-binary",
      "prefer-not-to-say": "Prefer not to say",
      "prefer-not-to-say ": "Prefer not to say",
      "prefer_not_to_say": "Prefer not to say",
    };
    return map[normalized] || value;
  };

  const renderContactRows = () => (
    <div className="myprofile-contact-list">
      <div className="myprofile-contact-card">
        <div className="myprofile-contact-text">
          <span className="myprofile-contact-label">Email</span>
          <span className="myprofile-contact-value">{currentEmail || "Not provided"}</span>
        </div>
        <button
          type="button"
          className="myprofile-contact-edit"
          onClick={() => {
            setShowEmailSetting(true);
            setCurrentEmailScreen(2);
          }}
          aria-label="Edit email"
        >
          <img src={editicon} alt="Edit email" />
        </button>
      </div>
      <div className="myprofile-contact-card">
        <div className="myprofile-contact-text">
          <span className="myprofile-contact-label">Phone Number</span>
          <span className="myprofile-contact-value">{currentPhone || "Not provided"}</span>
        </div>
        <button
          type="button"
          className="myprofile-contact-edit"
          onClick={() => {
            setShowPhoneSetting(true);
            setCurrentPhoneScreen(2);
          }}
          aria-label="Edit phone number"
        >
          <img src={editicon} alt="Edit phone" />
        </button>
      </div>
    </div>
  );

  const renderProfileHeader = () => (
    <div className="myprofile-header-card-inner">
      <div className="myprofile-avatar-wrapper">
        <div className="myprofile-container">
          <div className="status-circle-container">
            <div className="status-circle-progress">
              <CircularProgressBarProfile value={userProfile?.profile_completion_percent} disabled={false} />
            </div>

            {userProfile?.profile_pic_url ? (
              <img
                src={userProfile.profile_pic_url}
                alt="Profile"
                className="status-circle-profile-image"
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            ) : (
              <div className="status-circle-profile-image">
                {`${(userProfile?.first_name?.[0] || "").toUpperCase()}${(userProfile?.last_name?.[0] || "").toUpperCase()}`}
              </div>
            )}

            <div className="myprofile-edit-icon" onClick={openEditModal}>
              <img src={editicon} alt="Edit" />
            </div>
            {isEditModalOpen && userProfile && (
              <EditPhotoModal
                isOpen={isEditModalOpen}
                onClose={closeEditModal}
                profileData={userProfile}
                onProfileUpdate={handleProfileUpdate}
                id={userProfile._id}
              />
            )}
          </div>
          <div className="myprofile-status">{userProfile?.profile_completion_percent}% Complete</div>
        </div>
      </div>
      <div className="myprofile-basic-details">
        <div className="myprofile-name">{`${userProfile?.first_name || ""} ${userProfile?.last_name || ""}`.trim() || ""}</div>
        {/* <div>{[formatDate(userProfile?.DOB), formatGender(userProfile?.gender)]
          .filter(Boolean)
          .map((item, idx) => (
            <div key={item || idx} className="myprofile-basic-meta">
              {item}
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );


  const modalWidth = useMemo(() => {
    if (screenWidth < 780) return "85%";
    if (screenWidth < 1280 && screenWidth > 780) return "50%";
    return "35%";
  }, [screenWidth]);

  if (profileDetailsLoading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <GradientBackground>
        <TopBar
          title="Profile"
          showBackButton={true}
          rightIcon={null}
          onBackClick={() => navigate("/dashboard")}
          useRegularArrow={!isDesktopView}
        />

        <div className="myprofile-profile-card">
          <div className="myprofile-profile-card-inner">
            <div className="myprofile-header-card">{renderProfileHeader()}</div>
            <div className="myprofile-contact-periodic-table">
              {renderContactRows()}
            </div>
          </div>
        </div>

        <ChatModal
          isOpen={showPhoneSetting && currentPhoneScreen === 2}
          isCloseNeed={true}
          width={modalWidth}
          height="auto"
          padding="18px"
          onClose={() => {
            setShowPhoneSetting(false);
            setCurrentPhoneScreen(1);
          }}
        >
          <PhoneSettingsScreen2
            onUpdateContactClick={() => setCurrentPhoneScreen(3)}
            currentPhone={currentPhone}
          />
        </ChatModal>

        <ChatModal
          isOpen={showPhoneSetting && currentPhoneScreen === 3}
          isCloseNeed={true}
          width={modalWidth}
          height="auto"
          padding="18px"
          onClose={() => {
            setShowPhoneSetting(false);
            setCurrentPhoneScreen(1);
          }}
        >
          <PhoneSettingsScreen3
            onVerifyOTP={() => {
              fetchUserProfileLatest();
              setCurrentPhoneScreen(1);
              setShowContactSuccessMessage(true);
              setTimeout(() => setShowContactSuccessMessage(false), 3000);
            }}
            onChangePhoneNumber={() => setCurrentPhoneScreen(1)}
          />
        </ChatModal>

        <ChatModal
          isOpen={showEmailSetting && currentEmailScreen === 2}
          isCloseNeed={true}
          width={modalWidth}
          height="auto"
          padding="18px"
          onClose={() => {
            setShowEmailSetting(false);
            setCurrentEmailScreen(1);
          }}
        >
          <EmailSettingsScreen2
            onUpdateEmailClick={() => setCurrentEmailScreen(3)}
            currentEmail={currentEmail}
          />
        </ChatModal>

        <ChatModal
          isOpen={showEmailSetting && currentEmailScreen === 3}
          isCloseNeed={true}
          width={modalWidth}
          height="auto"
          padding="18px"
          onClose={() => {
            setShowEmailSetting(false);
            setCurrentEmailScreen(1);
          }}
        >
          <EmailSettingsScreen3
            onVerifyEmail={async () => {
              try {
                setEmailUpdateLoading(true);
                await fetchUserProfileLatest();
              } finally {
                setEmailUpdateLoading(false);
              }
              setCurrentEmailScreen(1);
              setShowEmailSuccessMessage(true);
              setTimeout(() => setShowEmailSuccessMessage(false), 3000);
            }}
          />
        </ChatModal>

        {emailUpdateLoading && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.25)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
            <div className="loader-dots">Updating...</div>
          </div>
        )}
      </GradientBackground>
    </>
  );
};

export default Profile;
